<template>
  <j-modal
    :title="title"
    width="40%"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('表编号')" prop="meterId">
                <a-input v-model="model.meterId" :placeholder="$t('请输入表编号')" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('返厂状态')" prop="returnedState">
                <j-dict-select-tag v-model="model.returnedState" :showSearch="false" :placeholder="$t('请选择返厂状态')" dictCode="returned_state" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('返厂日期')" prop="returnedTime">
                <a-date-picker v-model="model.returnedTime" value-format="YYYY-MM-DD" :placeholder="$t('请选择返厂日期')" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('返厂原因')" prop="returnedType">
                <j-dict-select-tag v-model="model.returnedType" :showSearch="false" :placeholder="$t('请选择返厂原因')" dictCode="returned_reason" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('操作员')" prop="returnedBy">
                <j-select-user-by-dep v-model="model.returnedBy" :multi="false"></j-select-user-by-dep>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="model.returnedState!=1">
              <a-form-model-item :label="$t('完成日期')" prop="finishedTime">
                <a-date-picker v-model="model.finishedTime" value-format="YYYY-MM-DD" :placeholder="$t('请选择返厂日期')" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('返厂原因描述')" prop="returnedReason">
                <a-textarea v-model="model.returnedReason" :rows="4" :placeholder="$t('请输入返厂原因描述')" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>
    
    <script>
    import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
    import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
    import { httpAction, getAction, postAction } from '@/api/manage'
export default {
  name: 'MeterCycleModalReturnToFactory',
  components: {JSelectUserByDep,JDictSelectTag},
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: false,
      model: {},
      confirmLoading: false,
      url: {
        add: '/jeecg-charge/meterReturnedRecord/add',
        edit: '/jeecg-charge/meterReturnedRecord/edit',
      },
    }
  },
  computed: {
    validatorRules() {
      return {
        returnedState: [{ required: true, message: this.$t('请选择返厂状态'), trigger: 'change' }],
        returnedTime: [{ required: true, message: this.$t('请选择返厂日期'), trigger: 'change' }],
        finishedTime: [{ required: true, message: this.$t('请选择完成日期'), trigger: 'change' }],
        returnedType: [{ required: true, message: this.$t('请选择返厂原因'), trigger: 'change' }],
        returnedBy: [{ required: true, message: this.$t('请选择操作员'), trigger: 'change' }],
      }
    },
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.$refs.form
        .validate(valid => {
          if (valid) {
            this.confirmLoading = true
            let url = this.model.id ? this.url.edit : this.url.add;
            let message = this.model.id ? this.$t('编辑成功') : this.$t('新增成功')
            if(this.model.returnedState==1) delete this.model.finishedTime;
            postAction(url,this.model).then(res=>{
              if(res.success){
                this.$message.success(message);
                this.visible = false;
                this.$emit('ok');
              }else{
                this.$message.warning(res.message);
              }
            }).finally(()=>{
              this.confirmLoading = false
            })
          }
        })
        .catch(() => {
          this.confirmLoading = false
        })
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
  <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
</style>